import React from "react";
import { motion } from "framer-motion";

type FadeUpProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};

export const FadeUp: React.FC<FadeUpProps> = ({
  children,
  delay = 0,
  className,
}) => (
  <motion.div
    className={className}
    initial={false}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-50px" }}
    transition={{ duration: 0.6, delay }}
  >
    {children}
  </motion.div>
);
